import React,{Fragment} from 'react';
import NewTabletOrderItemBlock from './NewTabletOrderItemBlock'; 

const LoadMoreNewTabletOrdersNotificationModalItems = (props) => {
    return (
        <Fragment>
            <NewTabletOrderItemBlock
                list={props.Orders}
                handelOnClickTabletNewOrder={props.handelOnClickTabletNewOrder}
            />
            {
                props.total_new_tablet_notification_orders > 0 && props.total_new_tablet_notification_orders > props.Orders.length ?
                    <tr className="load_more_container text-center">
                        <td colSpan="4">
                            <div className="cursor-pointer"  onClick={()=> props.onClickHandleLoadMoreNewTabletNotificationOrderItems()}><i className="fas fa-angle-down show-more"></i></div>
                        </td>
                        {/* <span onClick={()=> props.loadMore()}>
                            Load More
                        </span> */}
                    </tr>
                :null
            }
            

    
        </Fragment>
    );
};

export default LoadMoreNewTabletOrdersNotificationModalItems;